import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import tw from "twin.macro"

import Layout, { PageTitle } from "../components/layout"
import SEO from "../components/seo"
import DocCard from "../components/doc-card"

import startSvg from "../images/getting-started.svg"
import labelsSvg from "../images/labels.svg"
import configSvg from "../images/configuration.svg"
import helpSvg from "../images/troubleshooting.svg"

const DocCardGrid = tw.div`grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 my-8`

const DocumentationPage = ({
  data: {
    start,
    labels,
    config,
    help
  },
}) => {
  const sections = [
    { 
      title: "Getting Started",
      sections: start.edges,
      image: startSvg
    },
    { 
      title: "Labels",
      sections: labels.edges,
      image: labelsSvg
    },
    { 
      title: "Configuration",
      sections: config.edges,
      image: configSvg
    },
    { 
      title: "Troubleshooting",
      sections: help.edges,
      image: helpSvg
    },
  ]

  return (
  <Layout>
    <SEO title="Documentation" />
    <PageTitle>Documentation</PageTitle>
    <DocCardGrid>
    {sections.map(section => <DocCard key={section.title} {...section}/>)}
    </DocCardGrid>
  </Layout>
)}

DocumentationPage.propTypes = {
  data: PropTypes.object,
}

export const pageQuery = graphql`
  query {
    start: allMarkdownRemark(filter: { frontmatter: { section: { eq: "start" }}}) {
      ...MarkdownRemarkConnectionFragment
    }
    labels: allMarkdownRemark(filter: { frontmatter: { section: { eq: "labels" }}}) {
      ...MarkdownRemarkConnectionFragment
    }
    config: allMarkdownRemark(filter: { frontmatter: { section: { eq: "config" }}}) {
      ...MarkdownRemarkConnectionFragment
    }
    help: allMarkdownRemark(filter: { frontmatter: { section: { eq: "help" }}}) {
      ...MarkdownRemarkConnectionFragment
    }
  }
  fragment MarkdownRemarkConnectionFragment on MarkdownRemarkConnection {
    edges {
      node {
        frontmatter {
          title
          slug
        }
        id
      }
    }
  }

`

export default DocumentationPage
